var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPinterestCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600,300c0,165.7-134.3,300-300,300S0,465.7,0,300S134.3,0,300,0S600,134.3,600,300z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.6,390.9c-22.2,0-43-12.2-50.2-26.2c0,0-11.9,48.3-14.5,57.7c-4.3,15.8-12.5,31.5-20.1,44 c-10.9,14.2-23.4,3.7-24.9-9.3c-0.5-14.4,0-31.4,3.6-47c4-17,26.4-114.3,26.4-114.3s-6.6-13.4-6.6-33.2c0-31.1,17.6-54.3,39.6-54.3 c18.7,0,27.7,14.3,27.7,31.5c0,19.2-12,47.9-18.1,74.4c-5.2,22.3,10.9,40.4,32.4,40.4c38.9,0,65.2-51.1,65.2-111.5 c0-46-30.3-80.4-85.5-80.4c-62.3,0-101.2,47.5-101.2,100.4c0,18.3,5.3,31.2,13.6,41.1c3.8,4.6,4.3,6.4,2.9,11.7 c-1,3.9-3.2,13.1-4.2,16.8c-1.4,5.3-5.6,7.2-10.3,5.2c-28.7-12-42.1-44.1-42.1-80.1c0-59.6,49.2-131,146.8-131 c78.4,0,130.1,58,130.1,120.2C438.5,329.4,393.7,390.9,327.6,390.9z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPinterestCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pinterest-circle.d91f0b74.svg";
export { ForwardRef as ReactComponent };